const createEnvironmentFlags = (
  development = false,
  staging = false,
  production = false
) => ({ development, staging, production });

const flags = {
  modularizedRegistryTile: createEnvironmentFlags(true, true, true),
  cartViewedEvent: createEnvironmentFlags(true, true, true),
  fastFacets: createEnvironmentFlags(true, true, false),
  preauthNewCardTypes: createEnvironmentFlags(true, true, true),
  seatingChartView2: createEnvironmentFlags(false, false, false),
  refactorMobileRsvp: createEnvironmentFlags(true, true, false),
  dynamicThemeCount: createEnvironmentFlags(true, true, true),
  preauthChecklistCta: createEnvironmentFlags(true, true, true),
  invitesPLPDraperJames: createEnvironmentFlags(false, false, false), // these need to be flipped at the same time
  invitesPLPLovelyBride: createEnvironmentFlags(false, false, false), // these need to be flipped at the same time
  invitesPLPHolidayCards: createEnvironmentFlags(true, true, true),
  invitesPDPCarousel: createEnvironmentFlags(true, true, true),
  websitesPDPCarousel: createEnvironmentFlags(true, true, true),
  invitesPDPCustomizeRedirect: createEnvironmentFlags(true, true, false),
  customizeUndoOnDelete: createEnvironmentFlags(true, true, true),
  customizeUndoOnAdd: createEnvironmentFlags(true, true, true),
  showCollaboratorLink: createEnvironmentFlags(true, true, true),
  PLPImgBigger: createEnvironmentFlags(true, true, true),
  invitesPDPmagnifier: createEnvironmentFlags(true, true, true),
  addressingListV2: createEnvironmentFlags(true, false, false),
  otherRegistriesTestEnabled: createEnvironmentFlags(true, true, false),
  persistentCart: createEnvironmentFlags(true, true, true),
  magnetInvites: createEnvironmentFlags(true, true, true),
  selectProductHeaderOptimizely: createEnvironmentFlags(true, true, true),
  invitesPlacementCards: createEnvironmentFlags(false, false, false), // INVITES-1172
  stdSizeSegments: createEnvironmentFlags(true, true, true), // INVITES-1228
  tycGenerator: createEnvironmentFlags(true, true, true),
  fontRenderFix: createEnvironmentFlags(true, true, false), // INVITES-1054
  digitalPreviewPage: createEnvironmentFlags(true, true, true), // INV-308
  invitesPLPEnableMotifs: createEnvironmentFlags(true, true, true), // INVITES-1109
  invitesPLPShowMatchingThemeCardsFirst: createEnvironmentFlags(
    true,
    true,
    true
  ), // INV-398
  pdpModalModule: createEnvironmentFlags(true, true, true),
  specificCustomizationError: createEnvironmentFlags(true, true, true), // INV-68
  filteredPLPUrls: createEnvironmentFlags(true, true, true), // INV-497
  newInvitesCartLayout: createEnvironmentFlags(true, true, true), // INV-152
  thankYouCardPastDateValid: createEnvironmentFlags(true, true, true), // MAS-730
  disableDigitalCards: createEnvironmentFlags(true, true, true), // INV-536
  marketplaceLive: createEnvironmentFlags(true, true, true),
  showProductTypeFiltersOnListingSideNav: createEnvironmentFlags(
    false,
    false,
    false
  ), // INV-595
  publicWebNavCartModal: createEnvironmentFlags(true, true, true),
  checkForExistingDraftsOnPDP: createEnvironmentFlags(true, true, true),
  trackPageContextRefactor: createEnvironmentFlags(true, true, false), // MAS-752
  warnOfUnsavedNote: createEnvironmentFlags(true, true, true), // INV-630 INV-643
  newPlpCardTile: createEnvironmentFlags(false, false, false), // INV-501
  collectAddressV2: createEnvironmentFlags(true, true, true), // WEDDINGS-1726
  useSharedContentEditor: createEnvironmentFlags(false, false, false), // INV-499
  plpFeaturedArtistFilter: createEnvironmentFlags(true, true, true),
  plpOrientationFilters: createEnvironmentFlags(true, true, true),
  useElementAttributesTYC: createEnvironmentFlags(true, true, true), // INV-722
  uploadCsvModalV2: createEnvironmentFlags(true, true, true), // WEDDINGS-1738
  holidayNav: createEnvironmentFlags(false, false, false), // MAS-777 , go live 11/11
  registryImportAccountPage: createEnvironmentFlags(true, true, true), // WEDDINGS-1501
  checkGeosuggest: createEnvironmentFlags(true, true, true), // WEDDINGS-1501
  isPrefillEventName: createEnvironmentFlags(true, true, false), // WEDDINGS-1781
  singleSampleAllCardTypes: createEnvironmentFlags(true, true, true), // INV-785
  singleSampleNoFoil: createEnvironmentFlags(true, true, true), // INV-784
  isEditPageHeaderV2: createEnvironmentFlags(true, true, true), // WEDDINGS-1459
  newPDPInvitations: createEnvironmentFlags(true, true, false), // INV-776
  confirmExitModalFlag: createEnvironmentFlags(true, true, false), // WEDDINGS-1785
  newBulkUpload: createEnvironmentFlags(true, true, true),
  PLPHeroes: createEnvironmentFlags(true, true, true), // INV-917
  newPaperTypesPdpMvp: createEnvironmentFlags(true, true, true), // INV-961
  websiteRegistryRedisgn: createEnvironmentFlags(true, true, true), // WEDDINGS-1509
  weddingLandingRedesign: createEnvironmentFlags(true, true, true), // PAR-6 and others
  websiteRSVPRedisgn: createEnvironmentFlags(true, true, true), // WEDDINGS-1840
  flagEventFormModalV2: createEnvironmentFlags(true, true, true), // WEDDINGS-1840
  guestlistLPv2: createEnvironmentFlags(true, true, true), // PAR-8
  useV3PlanningPage: createEnvironmentFlags(true, true, true), // PAR-7
  checklistLPv2: createEnvironmentFlags(true, true, true), // PAR-9
  updateWeddingsFlows: createEnvironmentFlags(true, true, false), // MAS-1026
  isEditPageV2: createEnvironmentFlags(true, true, true), // WEDDINGS-1840
  flagGuestListMobileFix: createEnvironmentFlags(true, true, false), // WEDDINGS-1820
  isManageMobileCmsActionsV2: createEnvironmentFlags(true, true, false), // WEDDINGS-1871
};

const getEnvironment = () => {
  const zolaEnv = window.zola && window.zola.env;
  switch (zolaEnv) {
    case 'development':
    case 'dev':
      return 'development';
    case 'staging':
    case 'stage':
      return 'staging';
    case 'production':
    case 'prod':
      return 'production';
    default:
      return 'production';
  }
};

const get = flag => {
  if (flags[flag]) {
    return Boolean(flags[flag][getEnvironment()]);
  }
  return false;
};

export default {
  get,
};



// WEBPACK FOOTER //
// ./src/util/featureFlags.js